import CategoryIcon from "@material-ui/icons/Category";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import { Resource } from "react-admin";
import { Route } from "react-router-dom";

import { AppResource } from "../../../types/resource.types";
import DeliveryMethods from "../../Brands/components/DeliveryMethods";
import BrandsMedia from "../../Brands/components/Media";
import Chat from "../../Chat";
import { OrdersList } from "../../Orders";
import ShowOrder from "../../Orders/components/OrderDetails";
import { ProductsCreate, ProductsEdit, ProductsList } from "../../Products";
import BulkProductsCreate from "../../Products/components/BulkCreate";
import ClubDashboard from "./Dashboard";
import AccountSettings from "../../AccountSettings";
import StoreProfile from "../../Profiles/StoreProfile";
import BrandFullNotificationList from "../../Brands/BrandsNotifications/BrandFullNotificationList";

export const storeAccount = {
  resources: [
    <Resource
      name={AppResource.products}
      list={ProductsList}
      edit={ProductsEdit}
      create={ProductsCreate}
      icon={CategoryIcon}
      options={{
        label: "Products",
      }}
    />,
    <Resource
      name={AppResource.orders}
      list={OrdersList}
      icon={LocalOfferIcon}
      options={{
        label: "Orders",
      }}
    />,
    <Resource name={AppResource.clients} />,
    <Resource name={AppResource.brandsCategories} />,
  ],
  customRoutes: [
    <Route exact path={`/${AppResource.orders}/:orderId`} component={ShowOrder} />,
    <Route exact path={`/${AppResource.chat}/:roomId`} component={Chat} />,
    <Route exact path={`/${AppResource.brandsDeliveryMethods}`} component={DeliveryMethods} />,
    <Route exact path={`/${AppResource.brandsMedia}`} component={BrandsMedia} />,
    <Route exact path={`/${AppResource.bulkProductsCreate}`} component={BulkProductsCreate} />,
    <Route exact path={`/${AppResource.settings}`} component={AccountSettings} />,
    <Route exact path={`/${AppResource.profile}`} component={StoreProfile} />,
    <Route exact path={`/${AppResource.notifications}`} component={BrandFullNotificationList} />,
  ],
  dashboard: ClubDashboard,
};
